import * as React from 'react'

import { List } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import type { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'

import ItemByDocument from './ItemByDocument'
import SingleFieldItem from './SingleItem'

interface FormFieldsListProps {
  fields: CustomizationField[]
  onClickItemSettings?: (field: CustomizationField) => void
}

const FormFieldsList = ({ fields, onClickItemSettings = () => undefined }: FormFieldsListProps) => {
  const grouped = groupBy(fields, (curr) => `${curr.resourceType}-${curr.identifier}`)

  const renderItemByDocument = (group: CustomizationField[]) => {
    const fieldForDefault = group.find((field) => field.documentType === 'default')
    const fieldForInvoice = group.find((field) => field.documentType === 'invoice')

    // Ensure both fields are present before rendering ItemByDocument
    if (fieldForDefault && fieldForInvoice) {
      return (
        <ItemByDocument
          fieldForDefault={fieldForDefault}
          fieldForInvoice={fieldForInvoice}
          onClickItemSettings={onClickItemSettings}
        />
      )
    } else {
      return null
    }
  }

  return (
    <List>
      {Object.values(grouped).map((group) => {
        const firstItem = group[0]
        if (!firstItem) return null //just to avoid TS error, this can never happen

        return (
          <List.Item key={firstItem?.identifier} data-testid={`${firstItem?.identifier}-field`}>
            {group.length === 1 ? (
              <SingleFieldItem field={firstItem} onClickItemSettings={onClickItemSettings} />
            ) : (
              renderItemByDocument(group)
            )}
          </List.Item>
        )
      })}
    </List>
  )
}

export default FormFieldsList
